module.exports = ".stat-card {\n    background-color: yellow;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.css
// module id = ./src/app/dashboard/dashboard.component.css
// module chunks = main